<template>
  <div class="doughnut-container">
    <div class="reading-dates">
      <div class="reading-start">
        <div class="date-label">Início da leitura</div>
        <div class="date-value">{{ dataInicio }}</div>
      </div>
      <div class="reading-end">
        <div class="date-label">Fim da leitura</div>
        <div class="date-value">{{ dataFim }}</div>
      </div>
    </div>
    <div class="chart-container">
      <canvas ref="doughnut" ></canvas>
      <div class="doughnut-info">
        <div class="consumption-value">{{ consumo }} L</div>
        <div class="consumption-label">consumidos</div>
        <div class="percentage">{{ percentual }}%</div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js';

export default {
  name: 'DoughnutChart',
  props: {
    consumo: {
      type: Number,
      required: true,
      default: 0
    },
    limite: {
      type: Number,
      required: true,
      default: 100
    },
    dataInicio: {
      type: String,
      default: '01/04/2025'
    },
    dataFim: {
      type: String,
      default: '30/04/2025'
    }
  },
  data() {
    return {
      chart: null,
      percentual: 0
    };
  },
  computed: {
    restante() {
      return Math.max(this.limite - this.consumo, 0);
    }
  },
  watch: {
    consumo() {
      this.updateChart();
    },
    limite() {
      this.updateChart();
    }
  },
  mounted() {
    this.createChart();
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    createChart() {
      this.calculatePercentage();
      
      const ctx = this.$refs.doughnut.getContext('2d');
      this.chart = new Chart(ctx, {
        type: 'doughnut',
        data: {
          datasets: [{
            data: [this.consumo, this.restante],
            backgroundColor: ['#63A9FF', '#D6EAF8'],
            borderWidth: 0
          }]
        },
        options: {
          cutoutPercentage: 80,
          responsive: true,
          maintainAspectRatio: true,
          devicePixelRatio: 2,
          rotation: -Math.PI / 2,
          legend: {
            display: false
          },
          tooltips: {
            enabled: false
          },
          hover: {
            mode: null
          },
          animation: {
            animateRotate: true,
            animateScale: false
          }
        }
      });
    },
    updateChart() {
      this.calculatePercentage();
      
      if (this.chart) {
        this.chart.destroy();
      }
      
      this.createChart();
    },
    calculatePercentage() {
      this.percentual = ((this.consumo / this.limite) * 100).toFixed(0);
    }
  }
};
</script>

<style scoped>
.doughnut-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 20px;
}

.reading-dates {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.reading-start, .reading-end {
  text-align: left;
}

.date-label {
  font-size: 0.85rem;
  color: #333;
}

.date-value {
  font-size: 0.95rem;
}

.chart-container {
  position: relative;
  width: 100%;
  max-width: 300px;
}

.doughnut-info {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  z-index: 10;
  width: 75%;
}

.consumption-value {
  font-size: 1.5rem;
  font-weight: bold;
  color: #63A9FF;
  margin-bottom: 0;
  line-height: 1.2;
}

.consumption-label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #63A9FF;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.percentage {
  font-size: 1.2rem;
  color: #63A9FF;
  font-weight: 600;
}
</style> 